import React from 'react';
import styled from "styled-components"
import LineDivider from '../LineDivider'

const AccountSummary = ({liabilitiesAccountSummary}) => {
    const showAccountSummary = ()=>{
        return liabilitiesAccountSummary.map((account,i)=>{
            return(
                <AccountDetail key={i}>
                    <div>
                        Account Number:
                    </div>
                    <div className="value">
                        {account.accountNumber}
                    </div>
                    <LineDivider />
                    <div>
                        IFSC Code:
                    </div>
                    <div className="value">
                        {account.ifscCode}
                    </div>
                    <LineDivider />
                    <div>
                        Branch Name:
                    </div>
                    <div className="value">
                        {account.branchName}
                    </div>
                </AccountDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {showAccountSummary()}
        </React.Fragment>
    );
};

const AccountDetail = styled.div`
    display:flex;
    flex-direction : column;
    margin-top : 15px;

    & .value{
        margin-top : 3px;
        font-weight: 500;
        color: #2c387a;
    }
`

export default AccountSummary;